<template>
  <div>
    <table>
      <tr>
        <td><u-input-number v-model="value" class="shifting-input" binary decimal hexadecimal /></td>
        <td>
          <b-form-checkbox v-model="rotate" switch>Rotate</b-form-checkbox>
        </td>
      </tr>
    </table>
    <table thead-class="d-none" :items="bits">
      <tr>
        <td><b-button pill @click="shiftLeft()"> &lt;&lt; </b-button></td>
        <td class="bit" v-for="(bit, index) in bits" :key="index">
          {{bit}}
        </td>
        <td><b-button pill @click="shiftRight()"> &gt;&gt; </b-button></td>
      </tr>
    </table>
  </div>
</template>

<script>

import UcrDrkInputNumber from '@/components/ucrdrk-input-number'
import {fillBinary} from '@/util/numbers'

export default {
  name: 'shifting',
  components: {
    'u-input-number': UcrDrkInputNumber
  },
  data () {
    return {
      value: {value: 0, base: 2},
      shiftedValue: 0,
      rotate: false
    }
  },
  computed: {
    bits: function () {
      var bits = fillBinary(this.shiftedValue, 16).split('')
      return bits
    }
  },
  watch: {
    value: function () {
      this.shiftedValue = this.value.value
    }
  },
  methods: {
    shiftLeft: function () {
      var rotation = ((0x8000 & this.shiftedValue) !== 0 && this.rotate) ? 0x1 : 0x0
      this.shiftedValue = ((this.shiftedValue << 1) % 65536) | rotation
    },
    shiftRight: function () {
      var rotation = ((0x0001 & this.shiftedValue) !== 0 && this.rotate) ? 0x8000 : 0x0000
      this.shiftedValue = ((this.shiftedValue >>> 1) % 65536) | rotation
    }
  }
}
</script>

<style scoped>
.shifting-input {
  width: 200px;
  max-width: 200px;
  min-width: 200px;
}

.bit {
  text-align: center;
  font-family: monospace;
  font-size: xx-large;
}

td {
  padding-right: 5px;
  padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/shifting.vue